var React = require('react');

function BasketInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.7,14.9h45.2c2.4,0,4.3,1.9,4.3,4.3v31.7c0,2.4-1.9,4.3-4.3,4.3H5.7c-2.4,0-4.3-1.9-4.3-4.3V19.7\n\t\tC1.4,17.3,3.3,14.9,5.7,14.9z","key":0}),React.createElement("path",{"d":"M42.3,14.9c0-7.7-6.3-13.5-13.5-13.5S14.9,7.7,14.9,14.9","key":1})]);
}

BasketInline.defaultProps = {"className":"stroke","viewBox":"0 0 56.7 56.7"};

module.exports = BasketInline;

BasketInline.default = BasketInline;
